var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.hideAutoCompleteList,
          expression: "hideAutoCompleteList",
        },
      ],
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.locationSearchInput,
            expression: "locationSearchInput",
          },
        ],
        attrs: {
          type: "text",
          placeholder: _vm.placeholder,
          name: _vm.name,
          autocomplete: "off",
          "aria-autocomplete": "list",
        },
        domProps: { value: _vm.locationSearchInput },
        on: {
          click: _vm.resolveGeoLocations,
          keydown: _vm.keydown,
          input: function ($event) {
            if ($event.target.composing) return
            _vm.locationSearchInput = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _vm.listVisible
        ? _c("div", { staticClass: "autocomplete-locations" }, [
            _c(
              "ul",
              _vm._l(_vm.geocodingLocations, function (location, index) {
                return _c(
                  "li",
                  {
                    staticClass: "autocomplete-locations__item",
                    class: {
                      "autocomplete-locations__item--active":
                        _vm.activeItem === index,
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.setInputValueTo(location.description)
                          },
                        },
                      },
                      [_vm._v(_vm._s(location.description))]
                    ),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }